import { render, staticRenderFns } from "./Places_Search.vue?vue&type=template&id=b4b90986"
import script from "./Places_Search.vue?vue&type=script&lang=js"
export * from "./Places_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports